document.addEventListener("DOMContentLoaded", ()=> {

    const openFilter = document.querySelector('.custom-button__filter');
    const closeFilter = document.querySelector('.custom-button__close');
    const asideFilter = document.querySelector('aside.sidebar-section');
    const html = document.querySelector('html');
    const body = document.querySelector('body');

    if (openFilter) {
        openFilter.addEventListener('click', () => {
            asideFilter.classList.add('active');
            html.classList.add('overflow__hidden');
            body.classList.add('overflow__hidden');
        });
    }

    if (closeFilter) {
        closeFilter.addEventListener('click', () => {
            asideFilter.classList.remove('active');
            html.classList.remove('overflow__hidden');
            body.classList.remove('overflow__hidden');
        });
    }

    let menuClose = document.querySelector('.close__menu button');
    let mobileMenuToggleIcon = document.querySelector('.mobile-menu__toggle-icon');
    let mobileMenuToggleButton = document.querySelector('.mobile-menu__toggle-button');

    menuClose.addEventListener('click', () => {
        mobileMenuToggleButton.setAttribute('data-show-mobile-menu', 'false');

        mobileMenuToggleIcon.classList.remove('is-active');
        body.classList.remove('mobile-menu--opened');
    });

    let productForm = document.querySelector('.product-form_button');
    if (productForm) {
        document.querySelector('.product-form_button').addEventListener('click', function () {
            // let chatButton = document.querySelector(".upsy-plugin").shadowRoot.querySelector("div p");
            // if (chatButton) {
            //     chatButton.click();
            // }
        });

        if (document.getElementById('dummy-chat-button-iframe')) {
            document.querySelector('.product-form_button').addEventListener('click', function () {
                if (document.getElementById('dummy-chat-button-iframe').contentWindow.document.querySelector('button')) {
                    document.getElementById('dummy-chat-button-iframe').contentWindow.document.querySelector('button').click()
                }
            });
        }

    }
});